import axios from 'axios';
import { clearUserInfo } from './commonFunctions';
import store from '@store/store';
import { startLoading, stopLoading } from '@store/LoadingSlice';
import { setMessage } from '@store/messageSlice';

// Axios 인스턴스 생성
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
});

// 요청 인터셉터 설정 (토큰 추가)
axiosInstance.interceptors.request.use(
  (config) => {
    // 전역 로딩 스킵 헤더가 있으면 로딩을 시작하지 않음
    if (!config.headers['X-Skip-Global-Loading']) {
      store.dispatch(startLoading());
    }

    const userInfo = localStorage.getItem('userInfo');

    if (userInfo) {
      const token = JSON.parse(userInfo).token;
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // 전역 로딩 스킵 헤더가 있으면 로딩을 중지하지 않음
    if (!error.config?.headers?.['X-Skip-Global-Loading']) {
      store.dispatch(stopLoading());
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    // 전역 로딩 스킵 헤더가 있으면 로딩을 중지하지 않음
    if (!response.config.headers['X-Skip-Global-Loading']) {
      store.dispatch(stopLoading());
    }
    return response;
  },
  (error) => {
    // 전역 로딩 스킵 헤더가 있으면 로딩을 중지하지 않음
    if (!error.config?.headers?.['X-Skip-Global-Loading']) {
      store.dispatch(stopLoading());
    }
    const status = error.response?.status;
    
    if (status === 401) {
      if (!error.config?.headers?.['X-Skip-Global-Loading']) {
        clearUserInfo(store.dispatch);
      }

    } else if (status === 403) {
      // 403 에러는 권한 문제이므로 로그아웃하지 않고 메시지만 표시
      const message = error.response?.data?.message || '접근이 거부되었습니다.';
      store.dispatch(
        setMessage({
          message: message,
          type: 'error',
        })
      );
    } else if (status === 400) {
      // 400 에러는 로그아웃하지 않고 메시지만 표시
      const message = error.response?.data?.message || '잘못된 요청입니다.';
      store.dispatch(
        setMessage({
          message: message,
          type: 'error',
        })
      );
    } else {

      const message =
        error.response?.data?.message ||
        error.message ||
        '서버에서 알 수 없는 오류가 발생했습니다.';

      store.dispatch(
        setMessage({
          message: message,
          type: 'error',
        })
      );

    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
